$(function(){

    $('.LpCareerVideoModal').each(function(){

        // get modal and video
        const $modal = $(this);
        const $video = $modal.find('video');

        // when modal is shown, play video
        $modal.on('shown.bs.modal', function(){
            $video.trigger('play');
        });

        // when modal is hidden, reload it
        $modal.on('hidden.bs.modal', function(){
            $video.trigger('load');
        });

    });

});